import React from 'react'
import { Masonry } from '@mui/lab'
import { MetricsCardsGridProps } from './types'
import MetricsCard from './MetricsCard'
import { Fade } from '@mui/material'

const MetricsCardsGrid = ({ cards, viewMode }: MetricsCardsGridProps) => {
    return (
        <Fade in key={viewMode} timeout={800}>
            <Masonry
                columns={{ xs: 1, sm: 2, md: 3 }}
                spacing={2}
                sequential
                sx={{
                    width: 'calc(100% + 16px)',
                }}
            >
                {cards.map((card) => {
                    const cardViewMode = card.legend ? 'graphs' : viewMode
                    // @TODO metrics - implement empty placeholder for all cards
                    return <MetricsCard key={card.id} data={card} viewMode={cardViewMode} />
                })}
            </Masonry>
        </Fade>
    )
}

export default MetricsCardsGrid
